// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".font-selector{position:relative;height:100%;overflow-y:auto;text-align:left}.font-selector .font-item{border-bottom:1px solid #f3f3f3;padding:8px 4px;cursor:pointer}.font-selector .font-item svg{width:18px;fill:#555;margin-right:8px;margin-left:2px;vertical-align:middle}.font-selector .font-item span{vertical-align:middle}.font-selector .font-item:hover{background-color:#eefafe}.font-selector .font-item:last-child{border-bottom:none}", ""]);
// Exports
module.exports = exports;
